<div class="container pb-5">
    <h2 class="text-center pb-5">Check out some action shots!</h2>
    <app-instafeed></app-instafeed>
</div>